"use strict";
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.WhirlWindAbilityHandler = exports.WhirlWindActorAbilityFactory = exports.WhirlWindAbilityArgs = void 0;
const __1 = require("../..");
const AbilityType_1 = require("../../core/abilities/AbilityType");
const AbilityDamage_1 = require("../../core/AbilityDamage");
const ActorAbilityState_1 = require("../../core/actors/ActorAbilityState");
const Duration_1 = require("../../core/Duration");
const Vulnerability_1 = require("../../core/effects/core/Vulnerability");
const Registries_1 = require("../../core/state/Registries");
const Target_1 = require("../../core/Target");
class WhirlWindAbilityArgs {
    constructor(target) {
        this.target = target;
        this.__type = AbilityType_1.AbilityType.Whirlwind;
        this.__typeName = "Whirlwind";
    }
}
exports.WhirlWindAbilityArgs = WhirlWindAbilityArgs;
let WhirlWindActorAbilityFactory = class WhirlWindActorAbilityFactory {
    mk() {
        return new ActorAbilityState_1.ActorAbilityState("Whirlwind", "AllEnemies", 6);
    }
};
WhirlWindActorAbilityFactory = __decorate([
    Registries_1.ActorAbilities.register("Whirlwind")
], WhirlWindActorAbilityFactory);
exports.WhirlWindActorAbilityFactory = WhirlWindActorAbilityFactory;
let WhirlWindAbilityHandler = class WhirlWindAbilityHandler {
    init(sequence, container, actorId) { }
    activate(sequence, container, ability) {
        const targets = container.selectLivingTargets(ability.invokerId, Target_1.Target.AllEnemies);
        let targetsHit = 0;
        container.applyMultiAttack({
            sequence,
            attackerId: ability.invokerId,
            abilityKey: ability.args.__typeName,
            attackType: "melee",
            targets: [
                ...targets,
                ...(container.hasAttribute(ability.invokerId, "Charm_Warrior_1") ? targets : [])
            ].map((targetId, i) => ({
                targetId,
                damages: [
                    AbilityDamage_1.AbilityDamage.Power("Physical", 70)
                ],
                effects: [
                    {
                        targetId,
                        effect: new Vulnerability_1.VulnerabilityEffectArgs(2),
                        duration: Duration_1.Duration.Turns(5),
                    }
                ]
            })),
            onHit() {
                targetsHit++;
            },
            onCompleted: sequence => {
                if (targetsHit > 0) {
                    container.applyBuff({
                        sequence,
                        creatorId: ability.invokerId,
                        targetId: ability.invokerId,
                        effect: new __1.DamageAmplifyEffectArgs(30),
                        duration: Duration_1.Duration.Turns(3)
                    });
                }
            }
        });
    }
};
WhirlWindAbilityHandler = __decorate([
    Registries_1.Abilities.register(AbilityType_1.AbilityType.Whirlwind)
], WhirlWindAbilityHandler);
exports.WhirlWindAbilityHandler = WhirlWindAbilityHandler;
